import { COMING_SOON, LAST_CHANCE, LOW_STOCK, NOT_SOLD_ONLINE, NO_LONGER_FOR_SALE, OUT_OF_STOCK, SALE_LIMITATION, SOLD_OUT, UNTIL_STOCK_LASTS, VALUE_SET } from '../../common';
export const ppaLabelTypes = new Set([COMING_SOON, LAST_CHANCE, LOW_STOCK, NO_LONGER_FOR_SALE, NOT_SOLD_ONLINE, OUT_OF_STOCK, SALE_LIMITATION, SOLD_OUT, UNTIL_STOCK_LASTS, VALUE_SET]);
export const isPpaLabel = label =>
// Type casting used so that there can be type checking in PPA_LABEL_TYPES and yet it can
// be used for checking whether label has type PpaLabelType.
ppaLabelTypes.has(label ?? '');
//# sourceMappingURL=isPpaLabel.js.map